import { IProgramacaoColetaAnalise } from "@/interfaces/IProgramacaoColetaAnalise";
import { createAction } from "@reduxjs/toolkit";

const sync = createAction(
  "PROGRAMACAO_COLETA_ANALISE/sync",
  (items: IProgramacaoColetaAnalise[]) => ({
    payload: { items },
  })
);

export const programacaoAction = { sync };
